module.exports = __webpack_public_path__ + "img/1440.3305fa3e.jpg";